import api from "../../../api";

export function userLogin(email, password) {
  return api.post("login", { email, password });
}

export function getUserDetails() {
  return api.get("profile");
}

export function forgotPasswordRequest(email) {
  return api.post(`/forgot-password`, { email });
}

export function trayaGoogleLogin(token, fingerprint_id, is_incognito, fingerprint_details) {
  return api.post("login-google", { token, fingerprint_id, is_incognito, fingerprint_details });
}

export function resetPasswordApi(id, payload) {
  return api.put(`reset-password/${id}`, payload);
}

export const loginOtpApi = (payload) =>{
  return api.post(`login-otp`, payload)
}

export const getMyCallProviders = () =>{
  return api.get(`getMyCallProviders`)
}